import { MdBackup } from "react-icons/md";
import { FaRegNewspaper } from "react-icons/fa";

export default [
  {
    header: "Radio Administration",
  },
  {
    id: "backups_restore",
    acl: "backups_restore",
    title: "Backups & Restore",
    icon: <MdBackup size={20} />,
    children: [
      {
        id: "topics_backup",
        acl: "topics_backup",
        title: "Topics",
        icon: <MdBackup size={20} />,
        children: [
          {
            id: "topics_backup-news_backup",
            acl: "topics_backup",
            title: "News",
            icon: <FaRegNewspaper size={20} />,
            navLink: "/admin/backups/topics-deleted/News",
          },
          {
            id: "topics_backup-blog_backup",
            acl: "topics_backup",
            title: "Blog",
            icon: <FaRegNewspaper size={20} />,
            navLink: "/admin/backups/topics-deleted/Blog",
          },
          {
            id: "topics_backup-photos_backup",
            acl: "topics_backup",
            title: "Photos",
            icon: <FaRegNewspaper size={20} />,
            navLink: "/admin/backups/topics-deleted/Photos",
          },
          {
            id: "topics_backup-products_backup",
            acl: "topics_backup",
            title: "Products",
            icon: <FaRegNewspaper size={20} />,
            navLink: "/admin/backups/topics-deleted/Products",
          },
          {
            id: "topics_backup-partners_backup",
            acl: "topics_backup",
            title: "Partners",
            icon: <FaRegNewspaper size={20} />,
            navLink: "/admin/backups/topics-deleted/Partners",
          },
          {
            id: "topics_backup-services_backup",
            acl: "topics_backup",
            title: "Services",
            icon: <FaRegNewspaper size={20} />,
            navLink: "/admin/backups/topics-deleted/Services",
          },
        ],
      },
      {
        id: "rush_backup",
        acl: "rush_backup",
        title: "Rushs",
        icon: <MdBackup size={20} />,
        navLink: "/admin/backups/rushs",
      },
      {
        id: "episode_backup",
        acl: "episode_backup",
        title: "Episode",
        icon: <MdBackup size={20} />,
        navLink: "/admin/backups/episode",
      },
    ],
    parent: "Radio Administration",
  },
];
